import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
  public accountForm: FormGroup;
  public permissionForm: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  constructor(private ActivatedRoute: ActivatedRoute, private formBuilder: FormBuilder,  private http: HttpClient, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) {
    // this.createAccountForm();
    // this.createPermissionForm();
  }

  /* createAccountForm() {
    this.accountForm = this.formBuilder.group({
      fname: [''],
      lname: [''],
      email: [''],
      password: [''],
      confirmPwd: ['']
    })
  }
  createPermissionForm() {
    this.permissionForm = this.formBuilder.group({
    })
  } */

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/memberregbyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            this.accountForm.patchValue({
              _id: data.data._id,
              firstName: data.data.firstName,
              lastName: data.data.lastName,
              email: data.data.email,
              password: data.data.password,
              role: data.data.role,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    // alert(sessionStorage.getItem('department'))
    this.accountForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      role: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      _id: ['', ],
      
    });
  }

  selectedItemsList = [];
  checkedIDs = [];

  checkboxesDataList = [
    {
      component: 'Dashboard',
      isChecked: false
    },
    {
      component: 'Media',
      isChecked: false
    },
    
  ]

  changeSelection() {
    this.fetchSelectedItems()
  }

  fetchSelectedItems() {
    this.selectedItemsList = this.checkboxesDataList.filter((value, index) => {
      return value.isChecked
    });
  }

  fetchCheckedIDs() {
    this.checkedIDs = []
    this.checkboxesDataList.forEach((value, index) => {
      if (value.isChecked) {
        this.checkedIDs.push(value.component);
      }
    });
  }

  get f() { return this.accountForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.accountForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    var data = {
      "firstName" : this.accountForm.value.firstName,
      "lastName" : this.accountForm.value.lastName,
      "role" : this.accountForm.value.role,
      "email" : this.accountForm.value.email,
      "password" : this.accountForm.value.password,
      // "permissions" : this.selectedItemsList,
      "active" : 1,
      "admin" : sessionStorage.getItem('adminName'),
    };
    // console.log(data);
    this.http.post<any>(this.api_endpoint+'/memberreg', data).subscribe(
      res => {
        console.log(res)
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/users/list-user');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }else{
    var data1 = {
      "firstName" : this.accountForm.value.firstName,
      "lastName" : this.accountForm.value.lastName,
      "role" : this.accountForm.value.role,
      "email" : this.accountForm.value.email,
      "password" : this.accountForm.value.password,
      // "permissions" : this.selectedItemsList,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.accountForm.value._id,
    };
      console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/memberreg/', data1).subscribe(
      res => {
        console.log(res)
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          window.scrollTo(document.documentElement.clientWidth, 0);
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/users/list-user');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }
  

}
